export const GET_EMAIL_TEMPLATES_SUMMARIES_FAILURE = 'GET_EMAIL_TEMPLATES_SUMMARIES_FAILURE';
export const GET_EMAIL_TEMPLATES_SUMMARIES_REQUEST = 'GET_EMAIL_TEMPLATES_SUMMARIES_REQUEST';
export const GET_EMAIL_TEMPLATES_SUMMARIES_SUCCESS = 'GET_EMAIL_TEMPLATES_SUMMARIES_SUCCESS';


export const POST_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_FAILURE = 'POST_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_FAILURE';
export const POST_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_REQUEST = 'POST_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_REQUEST';
export const POST_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_SUCCESS = 'POST_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_SUCCESS';


export const POST_SEND_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_FAILURE = 'POST_SEND_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_FAILURE';
export const POST_SEND_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_REQUEST = 'POST_SEND_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_REQUEST';
export const POST_SEND_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_SUCCESS = 'POST_SEND_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_SUCCESS';

export const POST_EMAIL_TEMPLATE_FAILURE = 'POST_EMAIL_TEMPLATE_FAILURE';
export const POST_EMAIL_TEMPLATE_REQUEST = 'POST_EMAIL_TEMPLATE_REQUEST';
export const POST_EMAIL_TEMPLATE_SUCCESS = 'POST_EMAIL_TEMPLATE_SUCCESS';

export const GET_EMAIL_TEMPLATE_FAILURE = 'GET_EMAIL_TEMPLATE_FAILURE';
export const GET_EMAIL_TEMPLATE_REQUEST = 'GET_EMAIL_TEMPLATE_REQUEST';
export const GET_EMAIL_TEMPLATE_SUCCESS = 'GET_EMAIL_TEMPLATE_SUCCESS';

export const PUT_EMAIL_TEMPLATE_FAILURE = 'PUT_EMAIL_TEMPLATE_FAILURE';
export const PUT_EMAIL_TEMPLATE_REQUEST = 'PUT_EMAIL_TEMPLATE_REQUEST';
export const PUT_EMAIL_TEMPLATE_SUCCESS = 'PUT_EMAIL_TEMPLATE_SUCCESS';

export const DELETE_EMAIL_TEMPLATE_FAILURE = 'DELETE_EMAIL_TEMPLATE_FAILURE';
export const DELETE_EMAIL_TEMPLATE_REQUEST = 'DELETE_EMAIL_TEMPLATE_REQUEST';
export const DELETE_EMAIL_TEMPLATE_SUCCESS = 'DELETE_EMAIL_TEMPLATE_SUCCESS';

export const GET_EMAIL_TEMPLATE_TOKENS_FAILURE = 'GET_EMAIL_TEMPLATE_TOKENS_FAILURE';
export const GET_EMAIL_TEMPLATE_TOKENS_REQUEST = 'GET_EMAIL_TEMPLATE_TOKENS_REQUEST';
export const GET_EMAIL_TEMPLATE_TOKENS_SUCCESS = 'GET_EMAIL_TEMPLATE_TOKENS_SUCCESS';

export const PUT_EMAIL_TEMPLATE_SET_ACTIVE_FAILURE = 'PUT_EMAIL_TEMPLATE_SET_ACTIVE_FAILURE';
export const PUT_EMAIL_TEMPLATE_SET_ACTIVE_REQUEST = 'PUT_EMAIL_TEMPLATE_SET_ACTIVE_REQUEST';
export const PUT_EMAIL_TEMPLATE_SET_ACTIVE_SUCCESS = 'PUT_EMAIL_TEMPLATE_SET_ACTIVE_SUCCESS';

export const PUT_EMAIL_TEMPLATE_SET_CANCELLED_FAILURE = 'PUT_EMAIL_TEMPLATE_SET_CANCELLED_FAILURE';
export const PUT_EMAIL_TEMPLATE_SET_CANCELLED_REQUEST = 'PUT_EMAIL_TEMPLATE_SET_CANCELLED_REQUEST';
export const PUT_EMAIL_TEMPLATE_SET_CANCELLED_SUCCESS = 'PUT_EMAIL_TEMPLATE_SET_CANCELLED_SUCCESS';

export const SET_TEMPLATE_ID = 'SET_TEMPLATE_ID';
